// @flow
import { PencilSimple } from '@phosphor-icons/react'
import { Button } from 'antd'
import startsWith from 'lodash/startsWith'
import * as React from 'react'
import { createPortal } from 'react-dom'

import { SummaryAIAnswerModal } from '@/components/SummaryAIAnswerModal/SummaryAIAnswerModal'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'
import Tooltip from '@/ui/atoms/Tooltip'

import { DescriptionQuestionRenderTextEditor } from './DescriptionQuestionRenderTextEditor'

type Props = {
  value: string,
  withOverlay?: boolean,
  answer_id?: string,
}

export function DescriptionQuestionRender({
  value,
  withOverlay,
  answer_id,
}: Props): React.Node {
  const [answer, setAnswer] = React.useState(value)

  const updateParams = useUpdateURLSearchParams()
  const searchParams = useSearchParams()

  const isHtml = startsWith(answer, '<')
  const isHtmlOverride = (answer || '').includes('<p>')
  const isEditing = searchParams.get('edit_summary_ai_answer') === 'true'

  if (isHtml || isHtmlOverride) {
    return (
      <>
        <div className="relative [&:hover_.description-edit-button]:block">
          {answer_id ? (
            <Tooltip title="Edit Summary AI Answer">
              <Button
                className="description-edit-button absolute right-0 top-0 hidden"
                icon={<PencilSimple />}
                onClick={() => updateParams(['edit_summary_ai_answer', 'true'])}
              />
            </Tooltip>
          ) : null}
          <DescriptionQuestionRenderTextEditor value={answer} />
        </div>
        {createPortal(
          isEditing ? (
            <SummaryAIAnswerModal
              {...{
                value: answer,
                setAnswer,
                onCancel: () => setAnswer(value),
                answer_id,
              }}
            />
          ) : null,
          document.body
        )}
      </>
    )
  }

  return <DescriptionQuestionRenderTextEditor value={value} />
}

export default DescriptionQuestionRender
